import { memo } from 'react';

import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';

import styles from './KnmPreview.module.scss';
import { KnmSubtitle } from './KnmSubtitle';
import { parseErknmValue } from '../common/parseErknmValue';
import { KnmChangeWarning } from './KnmChangeWarning';

interface IErknmControlProps {
  passportData: IKnmPreview;
}

export const ErknmControl = memo(({ passportData }: IErknmControlProps) => {
  const kindControl =
    passportData.inspectionErknm?.kindControl && parseErknmValue(passportData.inspectionErknm.kindControl.value);

  const kindControlLabel = () => {
    if (!kindControl) {
      return '';
    }

    if (passportData.transferred && passportData.transferringAuthorities) {
      const ervkTransferringTitles = passportData.transferringAuthorities
        .filter(x => x.title !== undefined && x.title !== null)
        .map(x => x.title);
      const ervkTransferringShortTitles = passportData.transferringAuthorities
        .filter(x => x.shortTitle !== undefined && x.shortTitle !== null)
        .map(x => x.shortTitle);

      if (ervkTransferringShortTitles.length) {
        return `${kindControl.number} - ${kindControl.title} - передано от ${ervkTransferringShortTitles.join(', ')}`;
      }
      if (ervkTransferringTitles.length) {
        return `${kindControl.number} - ${kindControl.title} - передано от ${ervkTransferringTitles.join(', ')}`;
      }
    }

    return `${kindControl.number} - ${kindControl.title}`;
  };

  return (
    <div className={styles.ColumnContent}>
      <KnmChangeWarning
        oldKnoOrganization={passportData?.oldKnoOrganization}
        date={passportData?.dateReasonChangeKno}
        type={'KNO'}
      />
      <KnmSubtitle title="Контрольный (надзорный) орган">
        {passportData.inspectionErknm?.knoOrganization && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Наименование органа контроля</div>
            <div className={styles.ColValue}>
              {parseErknmValue(passportData.inspectionErknm.knoOrganization.value)?.fullName}
            </div>
          </div>
        )}
        {passportData.inspectionErknm?.kindControl && (
          <div className={styles.Row}>
            <div className={styles.ColText}>Вид контроля (надзора) и его номер</div>
            <div className={styles.ColValue}>{`${kindControlLabel()}`}</div>
          </div>
        )}
      </KnmSubtitle>
    </div>
  );
});
